export default __webpack_public_path__ + "static/media/home-page-img.9b1a98c5.png";